import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

import '@splidejs/splide/css';
import Splide from '@splidejs/splide';

jQuery(document).ready($ => {
    const splide = $('.splide');
    if (splide.length) {
        splide.each(function (index, el) {
            let customConfig = $(el).data('carousel');

            let config = {
                perPage: customConfig.slidesToShow,
                pagination: false,
                perMove: 1,
                breakpoints: Object.fromEntries(customConfig.responsive.map((breakpoint) => {
                    return [breakpoint.breakpoint, {
                        perPage: breakpoint.settings.slidesToShow
                    }]
                }))
            };
            console.log(config);
            new Splide(el, config).mount();
        });
    }
});